import { ApolloLink } from './ApolloLink';

export const empty = ApolloLink.empty;
